





































import { dateFormat, dateTransactionFormat } from '@/constants';
import {
  OpenCancelPendingClaimScreen,
  OpenCancelPendingInvestmentScreen,
  OpenCancelPendingReimbursementScreen,
  OpenInvestmentTransferScreen,
} from '@/mixins/get-content-mixins';
import { ExtendMixins } from '@/services';
import {
  MemberAccountResponseModel,
  PendingTransactionResponseModel,
} from '@/@types/member';

interface Data {
  dateFormat: string;
  dateTransactionFormat: string;
}

export default ExtendMixins(
  OpenCancelPendingClaimScreen,
  OpenCancelPendingInvestmentScreen,
  OpenCancelPendingReimbursementScreen,
  OpenInvestmentTransferScreen,
).extend({
  name: 'PendingTransactions',
  props: {
    /**
     * The pending transactions for the selected account.
     */
    transactions: {
      type: Array as () => PendingTransactionResponseModel[],
      required: true,
    },
  },
  data(): Data {
    return {
      dateFormat,
      dateTransactionFormat,
    };
  },
  computed: {
    account(): MemberAccountResponseModel {
      return this.$store.getters.currentAccount(this.$route.params.id);
    },
  },
  methods: {
    updateScheduledDeposit(selectedItem): void {
      if (selectedItem.transactionType === 'Investment') {
        this.openInvestmentTransferScreen({
          account: this.account,
          changeContribution: false,
          transaction: selectedItem,
        });
      }
    },
    isCancelable(item): boolean {
      /* UC-MBR-021: BR-1.46 */
      if (item.transactionType === 'Investment') { return true; }

      if (
        item.transactionType === 'Payment' &&
        item.transactionTable === 'MSCLAIM'
      ) {
        return true;
      }

      if (item.transactionType === 'Reimbursement') {
        if (
          item.transactionTable === 'MSCLAIM' ||
          item.transactionTable === 'ONLINE'
        ) {
          return true;
        }
      }

      return false;
    },
    isActionable(item): boolean {
      return this.isCancelable(item);
    },
    showCancelModal(item): void {
      switch (item.transactionType) {
        case 'Investment':
          this.openCancelPendingInvestmentScreen({
            transactionId: item.transactionId,
          });
          break;
        case 'Payment':
          this.openCancelPendingClaimScreen({
            transactionId: item.transactionId,
          });
          break;
        case 'Reimbursement':
          this.openCancelPendingReimbursementScreen({
            transactionId: item.transactionId,
          });
          break;
        default:
      }
    },
  },
});
